module.exports = __webpack_public_path__ + "img/2.fa1b46e5.jpg";